import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { getResponseMessage } from '../../../../utils/utils';
import { getCategoryChildren } from '../../../../crud/categories.crud';
import { ICategoryItem } from '../../categories/interfaces';

export const useGetChildrenCategories = (setCatalogCategories?: (categories: ICategoryItem[], id: number) => void) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState<ICategoryItem[] | null>([]);
  const [page, setPage] = useState({ page: 1, perPage: 20, total: 0 });
  const [success, setSuccess] = useState(false);

  const fetch = async (data: {
    id: number;
    per_page?: number;
    page?: number;
    only_active?: number;
    with_products?: number;
  }) => {
    setLoading(true);
    getCategoryChildren(data)
      .then((res: any) => {
        setCategories(res.data.data);
        setCatalogCategories?.(res.data.data, data.id);
        setSuccess(true);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { page, per_page, total } = res.data;
        setPage({ page, perPage: per_page, total });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 200);
      });
  };

  return { fetch, loading, categories, page, success };
};
